import { useTranslation } from 'react-i18next';
import { Alert, Chip, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { AttributeConflict } from '../types';

interface ConflictsTabProps {
  conflicts: AttributeConflict[];
}

const ConflictsTab = ({ conflicts }: ConflictsTabProps) => {
  const { t } = useTranslation('attributesAllergens');

  if (conflicts.length === 0) {
    return <Alert severity="success">{t('noConflictsForAttribute', 'No conflicts detected for this attribute.')}</Alert>;
  }

  return (
    <Paper variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{t('entity', 'Entity')}</TableCell>
            <TableCell>{t('conflictingAttributeCode', 'Conflicts With')}</TableCell>
            <TableCell>{t('description', 'Description')}</TableCell>
            <TableCell>{t('severity', 'Severity')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {conflicts.map((conflict) => (
            <TableRow key={conflict.id}>
              <TableCell>{conflict.entityName}</TableCell>
              <TableCell>{conflict.conflictingAttributeCode}</TableCell>
              <TableCell>{conflict.description}</TableCell>
              <TableCell><Chip label={conflict.severity}
                color="error"
                size="small" /></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default ConflictsTab;
